import moment from 'moment';

export const parseDateValue = (value, isRange) => {
  if (!value) return { startDate: null, endDate: null, currentDate: moment().startOf('month') };

  if (isRange) {
    const parts = value.split(' - ');
    if (
      parts.length === 2 &&
      moment(parts[0], 'DD/MM/YYYY').isValid() &&
      moment(parts[1], 'DD/MM/YYYY').isValid()
    ) {
      const start = moment(parts[0], 'DD/MM/YYYY');
      const end = moment(parts[1], 'DD/MM/YYYY');
      return {
        startDate: start,
        endDate: end,
        currentDate: start.clone().startOf('month'),
      };
    }
  } else {
    if (moment(value, 'DD/MM/YYYY').isValid()) {
      const start = moment(value, 'DD/MM/YYYY');
      return {
        startDate: start,
        endDate: null,
        currentDate: start.clone().startOf('month'),
      };
    }
  }

  return { startDate: null, endDate: null, currentDate: moment().startOf('month') };
};

export const formatMonthTitle = (monthMoment) => {
  const monthStr = monthMoment.format('MMMM YYYY');
  return monthStr.charAt(0).toUpperCase() + monthStr.slice(1);
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/SelectDate/utils/selectDateHelpers.js